import { FDHeadlineText, FDImage, FDStack } from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import useMobileLayout from 'Hooks/useMobileLayout';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { Carousel } from 'Packages/FacetDesign/Components/Experimental/Carousel';
import {
  PersonalizedStrategyDataCard,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStep/Content/Sections/PersonalizedSection/PersonalizedStrategyDataCard';
import { dataAttrs } from 'Helpers/Testing';
import { BorderedTransparentBox } from 'Packages/FacetDesign/Components/Experimental/BorderedTransparentBox';

const metaOverrides = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDHeadlineText,
    _customProps: { size: 'lg', align: 'center' },
  }, overrideReadOnly);

export const ExplorePageSection = ({ resource }) => {
  const isMobile = useMobileLayout();

  const items = resource.attr('cards')?.resources()?.list();
  const hasItems = items?.length > 0;
  // We'll hide the whole section if we don't have any cards in the section
  if (!hasItems) {
    return null;
  }

  const WrapperComponent = isMobile ? React.Fragment : BorderedTransparentBox;
  const wrapperProps = isMobile ? {} : {
    padding: 4,
    color: 'info',
    width: '100%',
  };

  return (
    <WrapperComponent {...wrapperProps}>
      <FDStack direction={'column'} paddingY={4} spacing={isMobile ? 3 : 4} alignItems={'center'} {...dataAttrs('explore-page-section')}>
        {resource.withRelationship(fr.relationships.image.name,
          (rel) => <FDImage alt={''} src={rel.link('related').url()} rounded={false} />,
          () => null)}
        <MetaControl attrName={'title'} resource={resource} metaOverrideSet={metaOverrides} />
        <MetaControl attrName={'subtitle'} resource={resource} metaOverrideSet={metaOverrides} />
        <Carousel maxCardsVisible={isMobile ? 1.1 : 3.1}>
          {hasItems ? items.map((d) => <PersonalizedStrategyDataCard key={d.id()} resource={d} />) : null}
        </Carousel>
      </FDStack>
    </WrapperComponent>
  );
};

ExplorePageSection.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
